import {
  fetchAllProductList,
  fetchCarousel,
  fetchCategories,
  fetchCategory,
  fetchProduct,
  fetchProductList,
  fetchRecommendProducts,
  getCommonCodeFetch,
} from 'common/api/fetcher/goods/queries'
import { useQuery } from 'react-query'

export default function goodsQuery() {
  // todo
}

export const useProductQuery = (productId: number | string) =>
  useQuery(['goods', 'products', productId], () => fetchProduct(productId))

export const useCategoriesQuery = () =>
  useQuery(['goods', 'categories'], () => fetchCategories())

export const useCategoryQuery = (categoryId: number | string) =>
  useQuery(['goods', 'categories', categoryId], () => fetchCategory(categoryId))

export const useAllProductListQuery = () =>
  useQuery(['goods', 'products', 'all'], fetchAllProductList, {
    cacheTime: 1000 * 60 * 30, // 30분간 캐시
    staleTime: 1000 * 60 * 30, // 30분간 stale 상태 유지
    retry: 1, // 실패 시 한 번만 재시도
    refetchOnWindowFocus: false, // 윈도우 포커스 시 재요청 방지
    refetchOnMount: false, // 컴포넌트 마운트 시 재요청 방지
  })

export const useProductListQuery = (categoryId: number | string) =>
  useQuery(['goods', 'categories', categoryId, 'products'], () =>
    fetchProductList(categoryId),
  )

export const getCommonCodeQuery = () =>
  useQuery(['goods', 'common'], () => getCommonCodeFetch())

export const useCarouselListQuery = (itemLength: number) =>
  useQuery(['carousel', itemLength], () => fetchCarousel(itemLength), {
    cacheTime: 1000 * 60 * 5, // 5분간 캐시
    staleTime: 0, // 항상 최신 데이터 조회
    retry: 2, // 실패 시 두 번 재시도
    refetchOnWindowFocus: false, // 윈도우 포커스 시 재요청 방지
    refetchOnMount: true, // 컴포넌트 마운트 시 무조건 재요청
  })

export const useRecommendProductsQuery = () =>
  useQuery(['goods', 'products', 'recommend'], () => fetchRecommendProducts(), {
    cacheTime: 1000 * 60 * 5, // 5분간 캐시
    staleTime: 0, // 항상 최신 데이터 조회
    retry: 2, // 실패 시 두 번 재시도
    refetchOnWindowFocus: false, // 윈도우 포커스 시 재요청 방지
    refetchOnMount: true, // 컴포넌트 마운트 시 재요청
  })
